import { tv } from 'tailwind-variants'

export const chatAccordionVariants = tv({
  slots: {
    accordion: 'flex mt-mili',
    clientProfile: 'h-full rounded-mili bg-white min-w-[350px]',
    assistant: 'h-full min-w-[350px]'
  }
})
